export default __webpack_public_path__ + "static/red-609eb8179a1e959749114a55e32b9d8f.gif";